import { PostHogProvider as BasePostHogProvider } from '@posthog/react';
import posthog from 'posthog-js';

const isPostHogEnabled = import.meta.env.VITE_POSTHOG_ENABLED === 'true';

if (isPostHogEnabled) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: '/ingest',
    ui_host: 'https://us.posthog.com',
    defaults: '2025-05-24',
    debug: import.meta.env.MODE === 'development',
    person_profiles: 'identified_only',
    capture_exceptions: true,
    session_recording: {
      maskTextSelector: '#sensitive',
    },
  });
}

function PostHogProvider({ children }: { children: React.ReactNode }) {
  if (!isPostHogEnabled) {
    return <>{children}</>;
  }

  return <BasePostHogProvider client={posthog}>{children}</BasePostHogProvider>;
}

export { posthog, PostHogProvider, isPostHogEnabled };
